import React from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const BookingCalendar = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl h-[95vh] overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white p-4">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-xl font-bold">Book Your 15-Minute Phone Call</h2>
            </div>
            <Button
              onClick={onClose}
              variant="ghost"
              size="sm"
              className="text-white hover:bg-blue-700 p-2"
            >
              <X size={20} />
            </Button>
          </div>
        </div>

        {/* Calendar Embed - Full Size */}
        <div className="flex-1 h-full">
          <iframe 
            src="https://link.insightdigitalagency.com/widget/booking/HcCmBqzTtfGEewWE3Kie" 
            style={{width: '100%', height: '100%', border: 'none'}} 
            scrolling="no" 
            id="Ykdk60G2JQiCcR9VXXl5_1755548305903"
            title="Book Your 15-Minute Phone Call"
            className="w-full h-full"
          />
        </div>
      </div>
    </div>
  );
};

export default BookingCalendar;
